import { signal } from '@angular/core';

/** The caller's Partner Portal access, as decided by the API's `access/`. */
export interface PartnerAccess {
  /** Primary organization is an MSP or MMSP. */
  eligible: boolean;
  portal: boolean;
  /** Only ever true alongside `portal`. */
  sales: boolean;
}

export const NO_PARTNER_ACCESS: PartnerAccess = { eligible: false, portal: false, sales: false };

/** A signal so nav builders that read it rebuild once `access/` answers. */
export const partnerAccess = signal<PartnerAccess>(NO_PARTNER_ACCESS);
